import React from 'react';
import { useIntl } from 'react-intl';
import Typography from '@nubank/nuds-web/components/Typography/Typography';
import Link from '@nubank/nuds-web/components/Link/Link';

import websitePage from 'hoc/websitePage/websitePage';
import OldPageSectionHeading from 'components/structure/OldPageSectionHeading';
import Section from 'components/structure/Section';
import Block from 'components/structure/Block/Block';
import { paddingBuilder } from 'styles/themeUtils';
import { maybeFormatPrefixedMessage } from 'utils/i18nUtils';

import { ReportsList } from './styles/ReportsList';
import TableRow from './patterns/TableRow/TableRow';

const reportLinks = [
  {
    labelKey: 'OMBUDSMAN_REPORT_1_2020',
    documentPath: 'https://cdn.nubank.com.br/p4rc/docs/ouvidoria-relatorio-semestral-1S2020-V7.pdf',
  },
  {
    labelKey: 'OMBUDSMAN_REPORT_2_2019',
    documentPath: '/docs/ouvidoria/2019-12.pdf',
  },
  {
    labelKey: 'OMBUDSMAN_REPORT_1_2019',
    documentPath: '/docs/ouvidoria/2019-06.pdf',
  },
  {
    labelKey: 'OMBUDSMAN_REPORT_2_2018',
    documentPath: '/docs/ouvidoria/2018-12.pdf',
  },
  {
    labelKey: 'OMBUDSMAN_REPORT_1_2018',
    documentPath: '/docs/ouvidoria/2018-06.pdf',
  },
  {
    labelKey: 'OMBUDSMAN_REPORT_2_2017',
    documentPath: '/docs/ouvidoria/2017-12.pdf',
  },
  {
    labelKey: 'OMBUDSMAN_REPORT_1_2017',
    documentPath: '/docs/ouvidoria/2017-01.pdf',
  },
];

export function Contract() {
  const intl = useIntl();

  const renderContractParagraph = (intlKey, path, gutterBottom = 1, forceRefresh = false) => (
    <Typography
      gutterBottom={gutterBottom}
      intlKey={`CONTRACT.CONTRACTS.${intlKey}`}
      intlValues={{
        link: (
          <Link
            forceRefresh={forceRefresh}
            color="primary"
            href={path}
            intlKey={`CONTRACT.CONTRACTS.${intlKey}_LINK`}
            intlValues={{
              variant: 'paragraph1',
            }}
          />
        ),
      }}
    />
  );

  const myRatesFormatMessage = maybeFormatPrefixedMessage(intl, 'CONTRACT.RATES');

  return (
    <>
      <OldPageSectionHeading intlKey="CONTRACT.PAGE_HEADING.TITLE" />
      <Section minHeight="auto">
        <Block
          blockWidth="60%"
          padding={{
            default: paddingBuilder.bottom(0),
            desktop: paddingBuilder.bottom(0),
          }}
        >
          <Typography
            intlKey="CONTRACT.CONTRACTS.TITLE"
            color="black"
            colorVariant="default"
            gutterBottom={2}
            variant="title"
            intlValues={{ br: <br /> }}
          />
          {renderContractParagraph('CARD', '/contrato/cartao', 1, true)}
          {renderContractParagraph('NUCONTA', '/contrato/conta', 1, true)}
          {renderContractParagraph('REWARDS', '/contrato/regulamento-rewards', 1, true)}
          {renderContractParagraph('LENDING', '/contrato/emprestimo-pessoal', 1, true)}

          <Typography
            gutterBottom="0"
            intlKey="CONTRACT.CONTRACTS.PJ"
            intlValues={{
              linkPJContract: (
                <Link
                  forceRefresh
                  color="primary"
                  href="https://nubank.com.br/mobile-web-views/nuconta-pj-contract.html"
                  intlKey="CONTRACT.CONTRACTS.PJ_LINK"
                />
              ),
              linkPJDebitContract: (
                <Link
                  forceRefresh
                  color="primary"
                  href="https://nubank.com.br/mobile-web-views/pj-debit-card-contract.html"
                  intlKey="CONTRACT.CONTRACTS.PJ_DEBIT_LINK"
                />
              ),
            }}
          />
        </Block>
      </Section>
      <Section minHeight="auto">
        <Block
          blockWidth="60%"
          padding={{
            default: paddingBuilder.bottom(0),
            desktop: paddingBuilder.bottom(0),
          }}
        >
          <Typography
            color="black"
            colorVariant="default"
            gutterBottom={2}
            intlKey="CONTRACT.CONTRACTS.PRIVACY_POLICY_TITLE"
            variant="title"
          />
          {renderContractParagraph('PRIVACY_POLICY', '/contrato/politica-privacidade', 0, true)}
        </Block>
      </Section>
      <Section minHeight="auto">
        <Block
          blockWidth="60%"
          padding={{
            default: paddingBuilder.bottom(0),
            desktop: paddingBuilder.bottom(0),
          }}
        >
          <Typography
            color="black"
            colorVariant="default"
            gutterBottom={2}
            intlKey="CONTRACT.RATES.CREDIT_CARD_TITLE"
            variant="title"
          />
          <TableRow
            title={myRatesFormatMessage('CREDIT_CARD_ANNUITY')}
            value={myRatesFormatMessage('CREDIT_CARD_ANNUITY_VALUE')}
          />
          <TableRow
            title={myRatesFormatMessage('CREDIT_CARD_PAYMENT')}
            value={myRatesFormatMessage('CREDIT_CARD_PAYMENT_VALUE')}
          />
          <TableRow
            title={myRatesFormatMessage('CREDIT_CARD_WITHDRAWAL')}
            value={myRatesFormatMessage('CREDIT_CARD_WITHDRAWAL_VALUE')}
          />
          <TableRow
            title={myRatesFormatMessage('CREDIT_CARD_OVERLIMIT')}
            value={myRatesFormatMessage('CREDIT_CARD_OVERLIMIT_VALUE')}
          />
          <TableRow
            title={myRatesFormatMessage('CREDIT_CARD_REISSUE')}
            value={myRatesFormatMessage('CREDIT_CARD_REISSUE_VALUE')}
          />
        </Block>
      </Section>
      <Section minHeight="auto">
        <Block
          blockWidth="60%"
          padding={{
            default: paddingBuilder.bottom(0),
            desktop: paddingBuilder.bottom(0),
          }}
        >
          <Typography
            color="black"
            colorVariant="default"
            gutterBottom={2}
            intlKey="CONTRACT.RATES.REWARDS_TITLE"
            variant="title"
          />
          <TableRow
            title={myRatesFormatMessage('REWARDS_TITLE_ANNUITY')}
            value={myRatesFormatMessage('REWARDS_TITLE_ANNUITY_VALUE')}
          />
        </Block>
      </Section>
      <Section minHeight="auto">
        <Block
          blockWidth="60%"
          padding={{
            default: paddingBuilder.bottom(0),
            desktop: paddingBuilder.bottom(0),
          }}
        >
          <Typography
            color="black"
            colorVariant="default"
            gutterBottom={2}
            intlKey="CONTRACT.RATES.INTEREST_TITLE"
            variant="title"
          />
          <TableRow
            title={myRatesFormatMessage('ROTATIVE_INTEREST')}
            value={myRatesFormatMessage('ROTATIVE_INTEREST_VALUE')}
          />
          <TableRow
            title={myRatesFormatMessage('INVOICE_INSTALLMENT_INTEREST')}
            value={myRatesFormatMessage('INVOICE_INSTALLMENT_INTEREST_VALUE')}
          />
          <TableRow
            title={myRatesFormatMessage('LATE_PAYMENT_INVOICE')}
            value={myRatesFormatMessage('LATE_PAYMENT_INVOICE_VALUE')}
          />
          <TableRow
            title={myRatesFormatMessage('LATE_FINE')}
            value={myRatesFormatMessage('LATE_FINE_VALUE')}
          />
          <TableRow
            title={myRatesFormatMessage('LENDING')}
            value={myRatesFormatMessage('LENDING_VALUE')}
          />
          <TableRow
            title={myRatesFormatMessage('WITHDRAWAL_CC_INTEREST')}
            value={myRatesFormatMessage('WITHDRAWAL_CC_INTEREST_VALUE')}
          />
        </Block>
      </Section>
      <Section minHeight="auto">
        <Block
          blockWidth="60%"
          padding={{
            default: paddingBuilder.bottom(0),
            desktop: paddingBuilder.bottom(0),
          }}
        >
          <Typography
            color="black"
            colorVariant="default"
            gutterBottom={2}
            intlKey="CONTRACT.RATES.CREDIT_CARD_INTERNATIONAL_PURCHASES_TITLE"
            variant="title"
          />
          <TableRow
            title={myRatesFormatMessage('REFERENCE_DOLLAR')}
            value={myRatesFormatMessage('REFERENCE_DOLLAR_VALUE')}
          />
          <TableRow
            title={myRatesFormatMessage('IOF')}
            value={myRatesFormatMessage('IOF_VALUE')}
          />
          <TableRow
            title={myRatesFormatMessage('WITHDRAWAL_CC_INTEREST')}
            value={myRatesFormatMessage('WITHDRAWAL_CC_INTEREST_VALUE')}
          />
          <TableRow
            title={myRatesFormatMessage('WITHDRAWAL_MAX_CET')}
            value={myRatesFormatMessage('WITHDRAWAL_MAX_CET_VALUE')}
          />
        </Block>
      </Section>
      <Section minHeight="auto">
        <Block
          blockWidth="60%"
          padding={{
            default: paddingBuilder.bottom(0),
            desktop: paddingBuilder.bottom(0),
          }}
        >
          <Typography
            color="black"
            colorVariant="default"
            gutterBottom={2}
            intlKey="CONTRACT.RATES.NUCONTA_TITLE"
            variant="title"
          />
          <TableRow
            title={myRatesFormatMessage('MAINTENANCE_FEE')}
            value={myRatesFormatMessage('MAINTENANCE_FEE_VALUE')}
          />
          <TableRow
            title={myRatesFormatMessage('TRANSFER')}
            value={myRatesFormatMessage('TRANSFER_VALUE')}
          />
          <TableRow
            title={myRatesFormatMessage('PIX')}
            value={myRatesFormatMessage('PIX_VALUE')}
          />
          <TableRow
            title={myRatesFormatMessage('DEPOSIT')}
            value={myRatesFormatMessage('DEPOSIT_VALUE')}
          />
          <TableRow
            title={myRatesFormatMessage('DEBIT_CARD')}
            value={myRatesFormatMessage('DEBIT_CARD_VALUE')}
          />
          <TableRow
            title={myRatesFormatMessage('WITHDRAWAL')}
            value={myRatesFormatMessage('WITHDRAWAL_VALUE')}
          />
        </Block>
      </Section>
      <Section minHeight="auto">
        <Block
          blockWidth="60%"
          padding={{
            default: paddingBuilder.bottom(0),
            desktop: paddingBuilder.bottom(0),
          }}
        >
          <Typography
            color="black"
            colorVariant="default"
            gutterBottom={2}
            intlKey="CONTRACT.RATES.PJ_TITLE"
            variant="title"
          />
          <TableRow
            title={myRatesFormatMessage('PJ_MAINTENANCE_FEE')}
            value={myRatesFormatMessage('PJ_MAINTENANCE_FEE_VALUE')}
          />
          <TableRow
            title={myRatesFormatMessage('PJ_TRANSFER')}
            value={myRatesFormatMessage('PJ_TRANSFER_VALUE')}
          />
          <TableRow
            title={myRatesFormatMessage('PJ_PIX')}
            value={myRatesFormatMessage('PJ_PIX_VALUE')}
          />
          <TableRow
            title={myRatesFormatMessage('PJ_DEBIT_CARD')}
            value={myRatesFormatMessage('PJ_DEBIT_CARD_VALUE')}
          />
          <TableRow
            title={myRatesFormatMessage('PJ_DEPOSIT_BOLETO')}
            value={myRatesFormatMessage('PJ_DEPOSIT_BOLETO_VALUE')}
          />
          <TableRow
            title={myRatesFormatMessage('PJ_CHARGING_BOLETO')}
            value={myRatesFormatMessage('PJ_CHARGING_BOLETO_VALUE')}
          />
          <TableRow
            title={myRatesFormatMessage('PJ_WITHDRAWAL')}
            value={myRatesFormatMessage('PJ_WITHDRAWAL_VALUE')}
          />
        </Block>
      </Section>
      <Section minHeight="auto">
        <Block
          blockWidth="60%"
          padding={{
            default: paddingBuilder.bottom(0),
            desktop: paddingBuilder.bottom(0),
          }}
        >
          <Typography
            color="black"
            colorVariant="default"
            gutterBottom={2}
            intlKey="CONTRACT.REPORTS.MORE_INFO_TITLE"
            variant="title"
          />
          <ReportsList>
            {reportLinks.map(({ labelKey, documentPath }) => (
              <li key={labelKey}>
                <Link
                  color="primary"
                  href={documentPath}
                  target="_blank"
                  intlKey={`CONTRACT.REPORTS.${labelKey}`}
                  variant="action"
                />
              </li>
            ))}
          </ReportsList>
        </Block>
      </Section>
      <Section minHeight="auto">
        <Block blockWidth="60%">
          <Typography
            gutterBottom={1.5}
            intlKey="NUBANK.COMPANY.NAME"
            variant="title"
          />
          <Typography intlKey="NUBANK.ADDRESS.STREET" />
          <Typography intlKey="NUBANK.ADDRESS.NEIGHBORHOOD_CITY_STATE" />
          <Typography intlKey="NUBANK.ADDRESS.POSTAL_CODE" />
        </Block>
      </Section>
    </>
  );
}

export default websitePage({
  routeKey: 'CONTRACT',
})(Contract);
